export const hasDeveloperRole = (userStore) => userStore?.redseaRoles?.includes('developer');
